import { render, staticRenderFns } from "./DialogConfirmDuplicatedCustomers.vue?vue&type=template&id=6969a955&"
import script from "./DialogConfirmDuplicatedCustomers.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmDuplicatedCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports